import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import withSearch from '../../_hocs/withSearch';
import Flex from '@wix/da-ds/pkg/Flex';
import noSearchResultStyles from './NoSearchResults.scss';
var enhance = compose(withSearch);
export var NoSearchResults = function (_a) {
    var unsetSearchQuery = _a.unsetSearchQuery, unsetSearchInput = _a.unsetSearchInput;
    var t = useTranslation().t;
    return (React.createElement(Flex, { fullWidth: true, fullHeight: true, direction: "column", justifyContent: "center", alignItems: "center" },
        React.createElement(SearchIcon, { className: noSearchResultStyles['icon'] }),
        React.createElement("div", { className: noSearchResultStyles['no-results'] }, t('mediapopup.search.noResultsFound')),
        React.createElement("div", { className: noSearchResultStyles['go-back-to'] },
            t('mediapopup.search.goBackTo'),
            React.createElement("button", { className: noSearchResultStyles['all-artworks-button'], onClick: function () {
                    unsetSearchQuery();
                    unsetSearchInput();
                } }, t('mediapopup.allArtworks')))));
};
NoSearchResults.displayName = 'NoSearchResults';
export default enhance(NoSearchResults);
//# sourceMappingURL=NoSearchResults.connected.js.map